import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

export default function BrandPage() {
  const { slug } = useParams();
  const [brand, setBrand] = useState(null);
  const [products, setProducts] = useState([]);
  const [allBrands, setAllBrands] = useState([]);

  useEffect(() => {
    if (!slug) return;
    api.get(`/brands/${slug}`).then((res) => setBrand(res.data)).catch(() => setBrand(false));
    api.get("/products", { params: { brand: slug, limit: 48 } }).then((res) => setProducts(res.data.items));
  }, [slug]);

  useEffect(() => {
    if (!slug) api.get("/brands").then((res) => setAllBrands(res.data));
  }, [slug]);

  if (!slug) {
    return (
      <div className="container-lookers py-12" data-testid="brands-index-page">
        <h1 className="font-heading font-semibold uppercase text-4xl mb-8 text-zinc-950">
          Shop By Brand
        </h1>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {allBrands.map((b) => (
            <Link key={b.slug} to={`/brands/${b.slug}`} className="border border-zinc-100 rounded-sm py-8 px-4 text-center hover:border-teal-300 hover:-translate-y-0.5 transition-all bg-white flex flex-col items-center gap-2" data-testid={`brand-index-tile-${b.slug}`}>
              {b.logo_url_black ? (
                <img src={`${process.env.REACT_APP_BACKEND_URL}${b.logo_url_black}`} alt={b.name} className="h-8 w-auto object-contain max-w-[130px]" />
              ) : (
                <div className="font-heading text-sm uppercase tracking-wide text-zinc-800">{b.name}</div>
              )}
              <div className="inline-flex items-baseline gap-1.5 rounded-full bg-teal-50 px-3.5 py-1.5 mt-1">
                <span className="text-lg font-heading font-extrabold leading-none text-teal-900">{b.product_count}</span>
                <span className="text-[10px] font-heading font-semibold uppercase tracking-wide text-teal-900">in stock</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }

  if (brand === false) return <div className="container-lookers py-24 text-center text-zinc-900">Brand not found.</div>;

  return (
    <div className="container-lookers py-12" data-testid="brand-page">
      {brand?.logo_url_black ? (
        <img src={`${process.env.REACT_APP_BACKEND_URL}${brand.logo_url_black}`} alt={brand.name} className="h-12 sm:h-16 w-auto object-contain max-w-[280px] mb-4" data-testid="brand-page-logo" />
      ) : (
        <h1 className="font-heading font-semibold uppercase text-4xl mb-3 text-zinc-950">
          Preloved {brand?.name} Glasses
        </h1>
      )}
      <p className="text-sm text-zinc-500 max-w-2xl mb-10">{brand?.description}</p>
      {products.length === 0 ? (
        <p className="text-sm text-zinc-400">No {brand?.name} frames available right now — check back soon.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
